export const NEXT_STREET_EVENT = "herent-mobility:next-street";
